import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { handlePostRequest } from '../service/PostTemplate';
import { endPoints } from '../Config';
import usePreferredLanguage from '../utilities/usePreferredLanguage';
import { translateUiText } from '../utilities/siteTranslations';

const ForcePasswordChange = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);

    const submit = async () => {
        const nextPassword = String(password || '').trim();
        const nextConfirmPassword = String(confirmPassword || '').trim();
        if (!nextPassword) return toast.error(t('Please enter a new password.'));
        if (nextPassword.length < 8) return toast.error(t('Password must be at least 8 characters long.'));
        if (nextPassword !== nextConfirmPassword) return toast.error(t('New password and confirm password do not match.'));

        try {
            setLoading(true);
            const response = await dispatch(
                handlePostRequest({ password: nextPassword }, endPoints.forcePasswordChange, true, false)
            );
            if (response && (response.status === 200 || response.status === 201)) {
                const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
                if (userDetails?.data?.adminUser) {
                    userDetails.data.adminUser.mustChangePassword = false;
                    localStorage.setItem('userDetails', JSON.stringify(userDetails));
                    localStorage.setItem('adminUser', JSON.stringify(userDetails));
                }
                toast.success(t('Password updated successfully. Please login again.'));
                localStorage.removeItem('userDetails');
                localStorage.removeItem('adminUser');
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-full-bg flex align-items-center justify-content-center min-h-screen px-3 py-4">
            <div className="login-overlay" />
            <div className="card p-4" style={{ maxWidth: '460px', width: '100%', zIndex: 1 }}>
                <h3 className="mb-2">{t('Password Update Required')}</h3>
                <p className="text-600 mb-4">
                    {t('For security reasons, you must create a new password before continuing.')}
                </p>
                <div className="mb-3">
                    <label className="block mb-2">{t('New Password')}</label>
                    <InputText
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full Login__Input"
                        placeholder={t('Enter new password')}
                        disabled={loading}
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2">{t('Confirm Password')}</label>
                    <InputText
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="w-full Login__Input"
                        placeholder={t('Re-enter new password')}
                        disabled={loading}
                    />
                </div>
                <Button
                    label={t('Update Password')}
                    icon="pi pi-save"
                    className="Login__Button w-full"
                    onClick={submit}
                    loading={loading}
                    disabled={loading}
                />
            </div>
        </div>
    );
};

export default ForcePasswordChange;
